export default __webpack_public_path__ + "static/media/apricityWorkLogo.0119796c.png";